import { ApiEntity } from "../types/index.js";
import { SearchFeatureUrl, getBaseUrl, getIdUrl } from "./url.js";
export const StyleUrl = {
    Search: new SearchFeatureUrl(true, ApiEntity.Style),
    Create: getBaseUrl(ApiEntity.Style),
    Read: getIdUrl(true, ApiEntity.Style),
    Update: getIdUrl(true, ApiEntity.Style),
    Delete: getIdUrl(true, ApiEntity.Style),
    Clone: getIdUrl(true, ApiEntity.Style),
    Export: getIdUrl(true, ApiEntity.Style, ApiEntity.Export),
    Import: getIdUrl(false, ApiEntity.Style, ApiEntity.Import),
    Load: getIdUrl(false, ApiEntity.Style, ApiEntity.Load),
};
